import type { CountryCode } from "libphonenumber-js"
import {
  isSupportedCountry,
  isValidPhoneNumber as libIsValidPhoneNumber
} from "libphonenumber-js"

/* eslint-disable no-useless-escape */
export const emailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const urlRegex =
  /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/

export function isValidPhoneNumber({
  value,
  dialCode,
  countryCode: phoneCountryCode
}: {
  value?: string
  dialCode?: string
  countryCode?: string
}): boolean {
  if (!value || !dialCode || !phoneCountryCode) {
    return false
  }
  const countryCode: CountryCode =
    phoneCountryCode?.toUpperCase() as unknown as CountryCode

  if (!isSupportedCountry(countryCode)) {
    return false
  }

  return libIsValidPhoneNumber(value, countryCode)
}
